<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="预估调整"
      :showFooter="false"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-table :data="tableData">
        <el-table-column label="店铺/个数" prop="storeName"></el-table-column>
        <el-table-column label="预估量" prop="planAmount"></el-table-column>
        <el-table-column label="预估调整" prop="planAdjust"></el-table-column>
        <el-table-column label="预估差异" prop="diffAmount"></el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  mixins: [mixin],
  data() {
    return {
      dialogVisible: false,
      tableData: []
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.updateVal();
    },
    init() {
      this.$q.preSalePlan.getPlanAdjustList({data:{
        code: this.data.goodsCode,
        planTime: this.planTime,
        type: '1' // 商品：1 产品：2
      }})
      .then(res=>{
        this.tableData = res.data;
      })
    }
  }
}
</script>

<style>

</style>